module.exports = __webpack_public_path__ + "static/award1-14bf5a8f49fa8f4f5fdaa83997c9c45b.png";